import type { AllRouteEndpoints } from "../routeTypes";

export const integrationsDirectCdiSources = "/integrations/direct/cdi/sources";

export const integrationsDirectCdiSourcesCacheKeys: AllRouteEndpoints[] = [integrationsDirectCdiSources];
